module.exports = __webpack_public_path__ + "img/thumbnail_GreaterFlamingo_m_normal.8f4d58e2.png";